class ShoeFinderOptions extends window.BAO.CustomElement({
  SuperClass: HTMLUListElement,
}) {
  setupListeners () {
    super.setupListeners()

    this.isPointerDown = false
    this.isDragging = false
    this.startX = 0
    this.startScrollLeft = 0
    this.dragThreshold = 5

    this.handlePointerDown = this.handlePointerDown.bind(this)
    this.handlePointerMove = this.handlePointerMove.bind(this)
    this.handlePointerUp = this.handlePointerUp.bind(this)
    this.handlePointerCancel = this.handlePointerCancel.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleScroll = this.handleScroll.bind(this)

    this.listeners.add(this, 'pointerdown', this.handlePointerDown)
    this.listeners.add(this, 'pointermove', this.handlePointerMove)
    this.listeners.add(this, 'pointerup', this.handlePointerUp)
    this.listeners.add(this, 'pointercancel', this.handlePointerCancel)
    this.listeners.add(this, 'mouseleave', this.handleMouseLeave)
    this.listeners.add(this, 'click', this.handleClick)
    this.listeners.add(this, 'scroll', this.handleScroll)

    this.updateScrollEndState()
  }

  handlePointerDown (e) {
    if (window.BAO.MediaBreakpoints.isXsViewport) return

    this.isPointerDown = true
    this.isDragging = false
    this.startX = e.clientX
    this.startScrollLeft = this.scrollLeft
  }

  handlePointerMove (e) {
    if (window.BAO.MediaBreakpoints.isXsViewport) return
    if (!this.isPointerDown) return

    const delta = e.clientX - this.startX

    if (Math.abs(delta) > this.dragThreshold) {
      this.isDragging = true
      this.setAttribute(this.draggingAttribute, 'true')
    }

    this.scrollLeft = this.startScrollLeft - delta

    this.updateScrollEndState()
  }

  handlePointerUp () {
    if (window.BAO.MediaBreakpoints.isXsViewport) return

    this.isPointerDown = false
    this.removeAttribute(this.draggingAttribute)

    setTimeout(() => {
      this.isDragging = false
    }, 0)
  }

  handlePointerCancel () {
    if (window.BAO.MediaBreakpoints.isXsViewport) return

    this.isPointerDown = false
    this.isDragging = false
    this.removeAttribute(this.draggingAttribute)
  }

  handleMouseLeave () {
    if (window.BAO.MediaBreakpoints.isXsViewport) return
    if (!this.isPointerDown) return

    this.isPointerDown = false
    this.isDragging = false
    this.removeAttribute(this.draggingAttribute)
  }

  handleClick (e) {
    if (window.BAO.MediaBreakpoints.isXsViewport) return

    if (this.isDragging) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  handleScroll () {
    this.updateScrollEndState()
  }

  updateScrollEndState () {
    if (this.isScrolledAllTheWayRight()) {
      this.setAttribute(this.scrollEndAttribute, 'true')
    } else {
      this.removeAttribute(this.scrollEndAttribute)
    }
  }

  isScrolledAllTheWayRight () {
    return this.scrollLeft + this.clientWidth >= this.scrollWidth - 1
  }

  get draggingAttribute () {
    return 'data-dragging'
  }

  get scrollEndAttribute () {
    return 'data-scroll-end'
  }
}

if (!customElements.get('shoe-finder-options')) {
  customElements.define('shoe-finder-options', ShoeFinderOptions, {
    extends: 'ul',
  })
}
